import React, { useEffect, useState, useRef } from "react";
import { FaBackward } from "react-icons/fa";
import "./ShoppingCart.css";
import bg from "../../Assets/Brands/bg.gif";
import { useSelector, useDispatch } from "react-redux";
import {
  removeFromCart,
  updateQuantity,
  selectCartTotalAmount,
  fetchCartAsync,
  addToCartAsync,
  removeFromCartAsync,
  updateQuantityAsync,
  clearCart,
} from "../../Features/Cart/cartSlice";

import { MdOutlineClose } from "react-icons/md";

import { Link } from "react-router-dom";

import success from "../../Assets/Brands/shop.gif";
import { ToastContainer, toast } from "react-toastify";
import axios from "axios";
import { motion, AnimatePresence } from "framer-motion";
import {
  FaCoins,
  FaVolumeMute,
  FaVolumeUp,
  FaWallet,
  FaShoppingBag,
} from "react-icons/fa";
import { updateUserTokens } from "../../Features/User/UserSlice";
import coinSound from "../../Assets/sounds/coin-sound.mp3";
import { useSound } from "../../hooks/useSound";
import { RiShoppingCartLine } from "react-icons/ri";
import { orange } from "@mui/material/colors";

const ShoppingCart = () => {
  const user = useSelector((state) => state.user.user);
  const MedicalStore = useSelector((state) => state.user.MedicalStore);
  const userId = user?._id;
  const { items, loading } = useSelector((state) => state.cart);
  const cartItems = useSelector((state) => state.cart.items);
  const SUBTOTAL = useSelector((state) => state.cart.totalAmount);
  const totalPrice = useSelector(selectCartTotalAmount);
  const dispatch = useDispatch();
  const [temp, setTemp] = useState({
    items: [],
    totalAmount: 0,
  });

  const [activeTab, setActiveTab] = useState("cartTab1");
  const [payments, setPayments] = useState(false);
  const [selectedPayment, setSelectedPayment] = useState("Cash on delivery");
  const [showTokenAnimation, setShowTokenAnimation] = useState(false);
  const [earnedTokens, setEarnedTokens] = useState(0);
  const { play, toggleMute, isMuted } = useSound(coinSound);

  // User address state for regular users
  const [userAddress, setUserAddress] = useState({
    street: '',
    contact: '',
    city: '',
    state: '',
    pincode: ''
  });

  const audioRef = useRef(new Audio(coinSound));

  // Fetch the cart data on mount
  useEffect(() => {
    if (cartItems.length === 0) {
      dispatch(fetchCartAsync(userId)); // Pass userId here
    }
  }, [cartItems.length, dispatch]);

  const handleTabClick = (tab) => {
    if (tab === "cartTab1" || cartItems.length > 0) {
      setTemp({
        items: cartItems,
        totalAmount: totalPrice,
      });
      setActiveTab(tab);
    }
  };

  const handleQuantityChange = (productId, quantity) => {
    if (quantity >= 1 && quantity <= 20) {
      dispatch(updateQuantity({ productID: productId, quantity: quantity }));
    }
    dispatch(
      updateQuantityAsync({ userId, productID: productId, quantity })
    ).then(() => {
      dispatch(fetchCartAsync(userId));
      console.log("Quantity updated successfully!");
    });
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handledeleteItem = (productId) => {
    // Optimistic UI update: remove item from the cart immediately
    dispatch(removeFromCart(productId));
    dispatch(removeFromCartAsync({ userId, productID: productId }))
      .then(() => {
        // After the API call, fetch the updated cart from the backend
        dispatch(fetchCartAsync(userId));
        console.log("Item removed successfully!");
      })
      .catch((error) => {
        // Optionally, revert the optimistic update here if an error occurs
        console.error("Error removing item:", error);
        dispatch(fetchCartAsync(userId));
      });
  };

  const currentDate = new Date();

  const formatDate = (date) => {
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const orderNumber = Math.floor(Math.random() * 100000);

  const [orderNum, setOrderNum] = useState();

  function formatOrderData(
    cartItems,
    orderNumber,
    currentDate,
    totalPrice,
    selectedPayment
  ) {
    const formattedDate = formatDate(currentDate);

    console.log("Sending order with userId:", userId);

    // Prepare delivery address based on user type
    const deliveryAddress = MedicalStore ? {
      fullName: user.name,
      phoneNumber: MedicalStore.mobile || user.MobileNumber,
      addressLine1: MedicalStore.address,
      addressLine2: '',
      city: 'Not specified',
      state: 'Not specified', 
      postalCode: '000000',
      landmark: ''
    } : {
      fullName: user.name,
      phoneNumber: userAddress.contact || user.MobileNumber,
      addressLine1: userAddress.street,
      addressLine2: '',
      city: userAddress.city,
      state: userAddress.state,
      postalCode: userAddress.pincode,
      landmark: ''
    };

    const orderData = {
      userId,
      date: formattedDate,
      orderItems: cartItems.map((item) => ({
        productID: item.productID,
        productName: item.productName,
        packof: item.packof,
        batchNumber: item.batchNumber,
        mrp: item.mrp,
        gst: item.gst,
        quantity: item.quantity,
        subtotal: item.dealRate * item.quantity,
      })),
      subtotal: totalPrice,
      shippingCost: totalPrice >= 1000 ? 0 : 99,
      vat: 0,
      total: totalPrice >= 1000 ? Math.round(totalPrice) : Math.round(totalPrice + 99),
      paymentMethod: selectedPayment,
      deliveryAddress
    };

    return axios
      .post("https://api.swasthmitra.com/api/transaction/createOrder", orderData)
      .then((response) => {
        if (response.status === 201) {
          const message = response.data.emailSent
            ? "Order placed successfully! Check your email for confirmation."
            : "Order placed successfully! Email confirmation could not be sent.";

          toast.success(message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });

          setOrderNum(response.data.orderNumber);
          return response.data.orderNumber;
        }
        throw new Error(response.data.message || "Failed to create order");
      })
      .catch((error) => {
        console.error("Error creating order:", error);
        toast.error(
          error.response?.data?.message ||
            "Error placing order. Please try again.",
          {
            position: "top-right",
            autoClose: 5000,
          }
        );
        throw error;
      });
  }

  const calculateTokens = (totalPrice) => {
    // Calculate tokens based on user's token percentage
    const tokenPercentage = user?.tokenPercentage ; // Default to 5% if not set
    const tokensEarned = Math.floor((totalPrice * tokenPercentage) / 100);
    return tokensEarned;
  };

  const handlePlaceOrder = async () => {
    if (user?.status === "pending") {
      toast.error("Please verify your account to place an order");
      return;
    }

    // Validate address for regular users (those without MedicalStore)
    if (!MedicalStore) {
      if (!userAddress.street.trim()) {
        toast.error("Please enter your street address");
        return;
      }
      if (!userAddress.contact.trim()) {
        toast.error("Please enter your contact number");
        return;
      }
      if (!userAddress.city.trim()) {
        toast.error("Please enter your city");
        return;
      }
      if (!userAddress.state.trim()) {
        toast.error("Please enter your state");
        return;
      }
      if (!userAddress.pincode.trim() || userAddress.pincode.length !== 6) {
        toast.error("Please enter a valid 6-digit pincode");
        return;
      }
    }

    // Calculate tokens based on total price and user's token percentage
    const tokensToEarn = calculateTokens(totalPrice);
    setEarnedTokens(tokensToEarn);

    try {
      // Place order
      const orderResponse = await formatOrderData(
        cartItems,
        orderNumber,
        currentDate,
        totalPrice,
        selectedPayment
      );

      if (orderResponse) {
        setShowTokenAnimation(true);
        play(); // Play the sound

        // Update user tokens in Redux and backend
        const updatedTokens = (user.tokens || 0) + tokensToEarn;
        dispatch(updateUserTokens({ userId: user._id, tokens: updatedTokens }));

        // Show success message
        toast.success(
          "Order placed successfully! Check your email for confirmation."
        );

        setTimeout(() => {
          setShowTokenAnimation(false);
          handleTabClick("cartTab3");
          window.scrollTo({ top: 0, behavior: "smooth" });
          setPayments(true);
        }, 3000);

        dispatch(clearCart());
      }
    } catch (error) {
      console.error("Error placing order:", error);
      toast.error("Error placing order. Please try again.");
    }
  };

  // Clean up audio on component unmount
  useEffect(() => {
    return () => {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
    };
  }, []);

  // Modify the cart breakdown section to show potential tokens
  
  const renderCartBreakdown = () => (
    <div className="shoppingBagTotal">
      <h3>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-shopping-bag">
          <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path>
          <line x1="3" y1="6" x2="21" y2="6"></line>
          <path d="M16 10a4 4 0 0 1-8 0"></path>
        </svg>
        Cart Breakdown
      </h3>
      
      <div className="shoppingBagTotalTableContainer">
        <table className="shoppingBagTotalTable">
          <tbody>
            <tr>
              <th>
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-shopping-cart">
                  <circle cx="9" cy="21" r="1"></circle>
                  <circle cx="20" cy="21" r="1"></circle>
                  <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
                </svg>
                Items total
              </th>
              <td>₹{Math.round(totalPrice)}</td>
            </tr>
            
            <tr className="delivery-row">
              <th>
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-truck">
                  <rect x="1" y="3" width="15" height="13"></rect>
                  <polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon>
                  <circle cx="5.5" cy="18.5" r="2.5"></circle>
                  <circle cx="18.5" cy="18.5" r="2.5"></circle>
                </svg>
                Delivery Charge
              </th>
              <td>
                {totalPrice >= 1000 ? (
                  <span className="free-delivery">
                    FREE <span className="delivery-note">(on orders over ₹1000)</span>
                  </span>
                ) : (
                  <span className="delivery-fee">
                    ₹99 <span className="delivery-note">(free over ₹1000)</span>
                  </span>
                )}
              </td>
            </tr>
            
            <tr className="grand-total-row">
              <th>
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-credit-card">
                  <rect x="1" y="4" width="22" height="16" rx="2" ry="2"></rect>
                  <line x1="1" y1="10" x2="23" y2="10"></line>
                </svg>
                Grand Total
              </th>
              <td>₹{Math.round(totalPrice >= 1000 ? totalPrice : totalPrice + 99)}</td>
            </tr>
            
            <tr className="points-row">
              <th>
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-award">
                  <circle cx="12" cy="8" r="7"></circle>
                  <polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88"></polyline>
                </svg>
                Coins Earn
              </th>
              <td>{calculateTokens(totalPrice)} Coins</td>
            </tr>
          </tbody>
        </table>
      </div>
      
      <button
        onClick={() => {
          handleTabClick("cartTab2");
          window.scrollTo({ top: 0, behavior: "smooth" });
        }}
        disabled={cartItems.length === 0}
        className={cartItems.length === 0 ? "disabled-btn" : ""}
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-shopping-cart">
          <circle cx="9" cy="21" r="1"></circle>
          <circle cx="20" cy="21" r="1"></circle>
          <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
        </svg>
        Proceed to Checkout
      </button>
    </div>
  );

  // Update the TokenAnimation component to show percentage
  const TokenAnimation = () => (
    <AnimatePresence>
      <ToastContainer />
      {showTokenAnimation && (
        <div className="token-animation-overlay" style={{ background: 'white' }}>
          <motion.div
            className="token-animation"
            initial={{ scale: 0, y: 100 }}
            animate={{ scale: 1, y: 0 }}
            exit={{ scale: 0, y: -100 }}
          >
            <div className="sound-toggle" onClick={toggleMute}>
              {isMuted ? <FaVolumeMute /> : <FaVolumeUp />}
            </div>

            {/* Shopping Bag and Coins Animation */}
            <motion.div className="bag-container">
            <img src={bg} alt="" />
              <motion.div
                className="shopping-bag"
                initial={{ scale: 0, y: 20 }}
                animate={{ scale: 1, y: 0 }}
                transition={{
                  duration: 0.5,
                  type: "spring",
                  stiffness: 260,
                  damping: 20,
                }}
              >

                
                <motion.div className="bag-opening" />
              </motion.div>

              <motion.div className="coins-wrapper">
                {[...Array(5)].map((_, i) => (
                  <motion.div
                    key={i}
                    className="coin"
                    initial={{
                      y: -200,
                      x: -100 + i * 50,
                      scale: 1.2,
                      rotate: 0,
                    }}
                    animate={[
                      {
                        y: -80,
                        x: 0,
                        rotate: 180,
                        transition: {
                          duration: 0.5,
                          delay: 0.7 + i * 0.1,
                          type: "spring",
                          stiffness: 200,
                        },
                      },
                      {
                        y: 20,
                        scale: 0.8,
                        rotate: 360,
                        transition: {
                          duration: 0.3,
                          delay: 1.2 + i * 0.1,
                          type: "spring",
                          stiffness: 120,
                        },
                      },
                    ]}
                  >
                   
                  </motion.div>
                ))}
              </motion.div>
            </motion.div>

            {/* Cart Success Animation */}
            <motion.div className="cart-success">
              <motion.div
                className="cart-icon"
                initial={{ scale: 0, y: 20 }}
                animate={{ scale: 1, y: 0 }}
                transition={{
                  delay: 2.2,
                  type: "spring",
                  stiffness: 260,
                  damping: 20,
                }}
              >
                <RiShoppingCartLine size={50} />
                <motion.div
                  className="cart-glow"
                  initial={{ scale: 0, opacity: 0 }}
                  animate={{ scale: 1.5, opacity: [0, 1, 0] }}
                  transition={{
                    delay: 2.5,
                    duration: 1,
                    times: [0, 0.5, 1],
                  }}
                />
              </motion.div>
              <motion.div
                className="check-mark"
                initial={{ scale: 0, rotate: -180 }}
                animate={{ scale: 1, rotate: 0 }}
                transition={{
                  delay: 3,
                  type: "spring",
                  stiffness: 260,
                  damping: 20,
                }}
              >
                ✓
              </motion.div>
            </motion.div>

            <motion.div className="token-info">
              <p className="token-percentage">
                {user?.tokenPercentage }% Reward Rate
              </p>
              <motion.p
                className="earned-tokens"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{
                  delay: 3.2,
                  duration: 0.5,
                  ease: "easeOut",
                }}
              >
                +{earnedTokens} Coins Earned!
              </motion.p>
              <p className="total-tokens">
                Total Coins: {(user?.tokens || 0) + earnedTokens}
              </p>
            </motion.div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );

  return (
    <div>
      <div className="shoppingCartSection">
        <h2><span style={{color:'#800080'}}>{cartItems.length} Items </span>in Your Cart</h2>

        <div className="shoppingCartTabsContainer">
          <div className={`shoppingCartTabs ${activeTab}`}>
            <button
              className={activeTab === "cartTab1" ? "active" : ""}
              onClick={() => {
                handleTabClick("cartTab1");
                setPayments(false);
              }}
            >
              <div className="shoppingCartTabsNumber">
                <h3>01</h3>
                <div className="shoppingCartTabsHeading">
                  <h3>Shopping Bag</h3>
                  <p>Manage Your Items List</p>
                </div>
              </div>
            </button>
            <button
              className={activeTab === "cartTab2" ? "active" : ""}
              onClick={() => {
                handleTabClick("cartTab2");
                setPayments(false);
              }}
              disabled={cartItems.length === 0}
            >
              <div className="shoppingCartTabsNumber">
                <h3>02</h3>
                <div className="shoppingCartTabsHeading">
                  <h3>Shipping and Checkout</h3>
                  <p>Checkout Your Items List</p>
                </div>
              </div>
            </button>
            <button
              className={activeTab === "cartTab3" ? "active" : ""}
              onClick={() => {
                handleTabClick("cartTab3");
              }}
              disabled={cartItems.length === 0 || payments === false}
            >
              <div className="shoppingCartTabsNumber">
                <h3>03</h3>
                <div className="shoppingCartTabsHeading">
                  <h3>Confirmation</h3>
                  <p>Review And Submit Your Order</p>
                </div>
              </div>
            </button>
          </div>
          <div className="shoppingCartTabsContent">
            {/* tab1 */}
            {activeTab === "cartTab1" && (
              <div className="shoppingBagSection">
                <div className="shoppingBagTableSection">
                  {/* For Desktop Devices */}
                  <table className="shoppingBagTable">
                    <thead>
                      <tr>
                        <th>Product</th>
                        <th></th>
                        <th>Price</th>
                        <th>Quantity</th>
                        <th>Subtotal</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {cartItems.length > 0 ? (
                        cartItems.map((item) => (
                          <tr key={item.productID}>
                            <td data-label="Product">
                              <div className="shoppingBagTableImg">
                                <Link
                                  to={`/product/${item?.productID}`}
                                  onClick={scrollToTop}
                                >
                                  <img src={item?.productImage} alt="" />
                                </Link>
                              </div>
                            </td>
                            <td data-label="">
                              <div className="shoppingBagTableProductDetail">
                                <Link to="/product" onClick={scrollToTop}>
                                  <h4>{item?.productName}</h4>
                                </Link>
                                <p>{item?.productReviews}</p>
                              </div>
                            </td>
                            <td
                              data-label="Price"
                              style={{ textAlign: "center" }}
                            >
                              ₹{item?.dealRate}
                            </td>
                            <td data-label="Quantity">
                              <div className="ShoppingBagTableQuantity">
                                <button
                                  onClick={() =>
                                    handleQuantityChange(
                                      item?.productID,
                                      item?.quantity - 1
                                    )
                                  }
                                >
                                  -
                                </button>
                                <input
                                  type="text"
                                  min="1"
                                  max="20"
                                  value={item.quantity}
                                  onChange={(e) =>
                                    handleQuantityChange(
                                      item.productID,
                                      parseInt(e.target.value)
                                    )
                                  }
                                />
                                <button
                                  onClick={() =>
                                    handleQuantityChange(
                                      item.productID,
                                      item.quantity + 1
                                    )
                                  }
                                >
                                  +
                                </button>
                              </div>
                            </td>
                            <td data-label="Subtotal">
                              <p
                                style={{
                                  textAlign: "center",
                                  fontWeight: "500",
                                }}
                              >
                                ₹{item.quantity * item.dealRate}
                              </p>
                            </td>
                            <td data-label="">
                              <MdOutlineClose
                                onClick={() => handledeleteItem(item.productID)}
                              />
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="6">
                            <div className="shoppingCartEmpty">
                              <span>Your cart is empty!</span>
                              <Link to="/shop" onClick={scrollToTop}>
                                <button>Shop Now</button>
                              </Link>
                            </div>
                          </td>
                        </tr>
                      )}
                    </tbody>
                    <tfoot>
                      <th
                        colSpan="6"
                        className="shopCartFooter"
                        style={{
                          borderBottom: "none",
                          padding: "20px 0px",
                        }}
                      ></th>
                    </tfoot>
                  </table>

                  {/* For Mobile devices */}

                  <div className="shoppingBagTableMobile">
                    {cartItems?.length > 0 ? (
                      <>
                        {cartItems?.map((item) => (
                          <div key={item?.productID}>
                            <div className="shoppingBagTableMobileItems">
                              <div className="shoppingBagTableMobileItemsImg">
                                <Link
                                  to={`/product/${item?.productID}`}
                                  onClick={scrollToTop}
                                >
                                  <img src={item?.productImage} alt="" />
                                </Link>
                              </div>
                              <div className="shoppingBagTableMobileItemsDetail">
                                <div className="shoppingBagTableMobileItemsDetailMain">
                                  <Link
                                    to={`/product/${item?.productID}`}
                                    onClick={scrollToTop}
                                  >
                                    <h4>{item?.productName}</h4>
                                  </Link>
                                  <p>{item?.productReviews}</p>
                                  
                                  <span style={{textDecoration:'line-through', fontSize:'11px'}}>₹{item?.mrp}</span>
                                  <span>₹{Math.round(item?.dealRate)}</span>
                                </div>
                                {/* <div className="shoppingBagTableMobileItemsDetailTotal">
                                  <MdOutlineClose
                                    onClick={() =>
                                      handledeleteItem(item.productID)
                                    }
                                  />
                                  <p>₹{item.quantity * item.dealRate}</p>
                                </div> */}

<div className="shoppingBagTableMobileQuantity">
  <button
    onClick={() =>
      handleQuantityChange(item?.productID, item?.quantity - 1)
    }
  >
    -
  </button>

  <input
    type="text"
    min="1"
    max="20"
    value={item?.quantity}
    onChange={(e) =>
      handleQuantityChange(
        item?.productID,
        parseInt(e.target.value)
      )
    }
  />

  <button
    onClick={() =>
      handleQuantityChange(item?.productID, item?.quantity + 1)
    }
  >
    +
  </button>

  {/* Cross button to delete item */}
  <button
    className="delete-button"
    onClick={() => handledeleteItem(item?.productID)}
    style={{
      marginLeft: '10px',
      background: 'transparent',
      border: 'none',
      fontSize: '20px',
      color: '#ff4d4f',
      cursor: 'pointer'
    }}
    aria-label="Remove item"
    title="Remove item"
  >
    &times;
  </button>
</div>

                              </div>
                            </div>
                          </div>
                        ))}
                      </>
                    ) : (
                      <div className="shoppingCartEmpty">
                        <span>Your cart is empty!</span>
                        <Link to="/shop" onClick={scrollToTop}>
                          <button>Shop Now</button>
                        </Link>
                      </div>
                    )}
                  </div>
                </div>
                {renderCartBreakdown()}
              </div>
            )}

            {/* tab2 */}
            {activeTab === "cartTab2" && (
              <div className="checkoutSection">
                <div className="checkoutDetailsSection">
                  <FaBackward
                    onClick={() => {
                      handleTabClick("cartTab1");
                      window.scrollTo({ top: 0, behavior: "smooth" });
                    }}
                  >
                    Back
                  </FaBackward>
                  <h4>Billing Details</h4>
                  <div className="checkoutDetailsForm">
                    <form>
                      {/* <div className="checkoutDetailsFormRow"> */}
                      <div>
                        <h3>Full Name:</h3>
                        <input type="text" placeholder={user.name} disabled />
                      </div>

                      {/* </div> */}
                      <div>
                        <h3>{MedicalStore ? 'Store-Name:' : 'Delivery Type:'}</h3>
                        <input 
                          type="text" 
                          placeholder={MedicalStore?.name || "Home Delivery"} 
                          disabled 
                          style={{
                            backgroundColor: '#f5f5f5',
                            cursor: 'not-allowed'
                          }}
                        />
                      </div>
                      <div>
                        <h3>Country:</h3>
                        <input type="text" placeholder="India" disabled />
                      </div>
                      <div>
                        <h3>Street Address: {!MedicalStore && <span style={{color: 'red'}}>*</span>}</h3>
                        <input 
                          type="text" 
                          placeholder={MedicalStore?.address || "Enter your delivery address"} 
                          value={MedicalStore?.address || userAddress.street}
                          onChange={(e) => !MedicalStore && setUserAddress({...userAddress, street: e.target.value})}
                          disabled={!!MedicalStore?.address}
                          required={!MedicalStore}
                          style={{
                            backgroundColor: MedicalStore ? '#f5f5f5' : 'white',
                            cursor: MedicalStore ? 'not-allowed' : 'text'
                          }}
                        />
                      </div>
                      <div>
                        <h3>Contact Number: {!MedicalStore && <span style={{color: 'red'}}>*</span>}</h3>
                        <input 
                          type="text" 
                          placeholder={MedicalStore?.mobile || "Enter your contact number"} 
                          value={MedicalStore?.mobile || userAddress.contact}
                          onChange={(e) => !MedicalStore && setUserAddress({...userAddress, contact: e.target.value})}
                          disabled={!!MedicalStore?.mobile}
                          required={!MedicalStore}
                          style={{
                            backgroundColor: MedicalStore ? '#f5f5f5' : 'white',
                            cursor: MedicalStore ? 'not-allowed' : 'text'
                          }}
                        />
                      </div>   
                      {/* Additional fields for regular users */}
                      {!MedicalStore && (
                        <>
                          <div>
                            <h3>City: <span style={{color: 'red'}}>*</span></h3>
                            <input 
                              type="text" 
                              placeholder="Enter your city" 
                              value={userAddress.city}
                              onChange={(e) => setUserAddress({...userAddress, city: e.target.value})}
                              required
                            />
                          </div>
                          <div>
                            <h3>State: <span style={{color: 'red'}}>*</span></h3>
                            <input 
                              type="text" 
                              placeholder="Enter your state" 
                              value={userAddress.state}
                              onChange={(e) => setUserAddress({...userAddress, state: e.target.value})}
                              required
                            />
                          </div>
                          <div>
                            <h3>Pincode: <span style={{color: 'red'}}>*</span></h3>
                            <input 
                              type="text" 
                              placeholder="Enter your pincode" 
                              value={userAddress.pincode}
                              onChange={(e) => setUserAddress({...userAddress, pincode: e.target.value})}
                              required
                              pattern="[0-9]{6}"
                              maxLength="6"
                            />
                          </div>
                        </>
                      )}
                    </form>
                  </div>
                </div>
                <div className="checkoutPaymentSection">
                  <div className="checkoutTotalContainer">
                    <h3>Your Order</h3>
                    <div className="checkoutItems">
                      <table>
                        <thead>
                          <tr>
                            <th>PRODUCTS</th>
                            <th>SUBTOTALS</th>
                          </tr>
                        </thead>
                        <tbody>
                          {temp?.items?.map((items) => (
                            <div key={items.productID}>
                             
                            </div>
                          ))}
                        </tbody>
                      </table>
                    </div>
                    <div className="checkoutTotal">
                      <table>
                        <tbody>
                          <tr>
                            <th>Item Total</th>
                            <td>₹{Math.round(totalPrice)}</td>
                          </tr>
                          <tr>
                            <th>Delivery</th>
                            <td>{totalPrice >= 1000 ? 'Free' :  '₹ 99'}</td>
                          </tr>
                          <tr>
                            <th>Total</th>
                            <td>₹{totalPrice >= 1000 ? Math.round(totalPrice) : Math.round(totalPrice + 99)}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  {/* <div className="checkoutPaymentContainer">
                    <label>
                      <input
                        type="radio"
                        name="payment"
                        value="Cash on delivery"
                        onChange={handlePaymentChange}
                      />
                      <div className="checkoutPaymentMethod">
                        <span>Cash on delivery</span>
                        <p>
                          Phasellus sed volutpat orci. Fusce eget lore mauris
                          vehicula elementum gravida nec dui. Aenean aliquam
                          varius ipsum, non ultricies tellus sodales eu. Donec
                          dignissim viverra nunc, ut aliquet magna posuere eget.
                        </p>
                      </div>
                    </label>

                    <div className="policyText">
                      Your personal data will be used to process your order,
                      support your experience throughout this website, and for
                      other purposes described in our{" "}
                      <Link to="/terms" onClick={scrollToTop}>
                        Privacy Policy
                      </Link>
                      .
                    </div>
                  </div> */}
                  <div className="Place-order">
                    <button onClick={handlePlaceOrder}>Place Order</button>
                  </div>
                </div>
              </div>
            )}

            {/* tab3 */}
            {activeTab === "cartTab3" && (
              <div className="orderCompleteSection">
                <div className="orderComplete">
                  <div className="orderCompleteMessage">
                    <div className="orderCompleteMessageImg">
                      <img src={success} alt="" />
                    </div>
                    <h3>Your order is completed!</h3>
                    <p>Thank you. Your order has been received.</p>
                  </div>
                  <div className="orderInfo" style={{
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
  gap: '20px',
  padding: '20px',
  fontSize:'14px',
  backgroundColor: '#fff',
  borderRadius: '8px',
  boxShadow: '0 2px 5px rgba(0,0,0,0.05)',
  border: '1px solid #eee'
}}>
  <div className="orderInfoItem" style={{
    padding: '10px',
    borderLeft: '3px solid #4CAF50'
  }}>
    <p style={{
      margin: '0 0 5px 0',
      fontSize: '0.9em',
      color: '#777',
      fontWeight: '500'
    }}>Order Number</p>
    <h4 style={{
      margin: '0',
      fontSize: '1.2em',
      color: '#333',
      fontWeight: '600'
    }}>{orderNum}</h4>
  </div>
  
  <div className="orderInfoItem" style={{
    padding: '10px',
    borderLeft: '3px solid #2196F3'
  }}>
    <p style={{
      margin: '0 0 5px 0',
      fontSize: '0.9em',
      color: '#777',
      fontWeight: '500'
    }}>Date</p>
    <h4 style={{
      margin: '0',
      fontSize: '1.2em',
      color: '#333',
      fontWeight: '600'
    }}>{formatDate(currentDate)}</h4>
  </div>
  
  <div className="orderInfoItem" style={{
    padding: '10px',
    borderLeft: '3px solid #FF9800'
  }}>
    <p style={{
      margin: '0 0 5px 0',
      fontSize: '0.9em',
      color: '#777',
      fontWeight: '500'
    }}>Total</p>
    <h4 style={{
      margin: '0',
      fontSize: '1.2em',
      color: '#333',
      fontWeight: '600'
    }}>
      ₹{Math.round(totalPrice >= 1000 ? totalPrice : totalPrice + 99)}
    </h4>
  </div>
  
  <div className="orderInfoItem" style={{
    padding: '10px',
    borderLeft: '3px solid #9C27B0'
  }}>
    <p style={{
      margin: '0 0 5px 0',
      fontSize: '0.9em',
      color: '#777',
      fontWeight: '500'
    }}>Payment Method</p>
    <h4 style={{
      margin: '0',
      fontSize: '1.2em',
      color: '#333',
      fontWeight: '600'
    }}>{selectedPayment}</h4>
  </div>
</div>
                  {/* <div className="orderTotalContainer" style={{
  fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
  maxWidth: '800px',
  margin: '20px auto',
  padding: '20px',
  backgroundColor: '#f9f9f9',
  borderRadius: '8px',
  boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
}}>
  <h3 style={{
    color: '#333',
    borderBottom: '2px solid #eee',
    paddingBottom: '10px',
    marginBottom: '20px'
  }}>Order Details</h3>
  
  <div className="orderItems" style={{ marginBottom: '30px' }}>
    <table style={{ 
      width: '100%',
      borderCollapse: 'collapse',
      marginBottom: '20px'
    }}>
      <thead>
        <tr style={{ 
          backgroundColor: '#f0f0f0',
          borderBottom: '1px solid #ddd'
        }}>
          <th style={{ 
            padding: '12px 15px',
            textAlign: 'left',
            fontWeight: '600',
            color: '#555'
          }}>PRODUCTS</th>
          <th style={{ 
            padding: '12px 15px',
            textAlign: 'right',
            fontWeight: '600',
            color: '#555'
          }}>SUBTOTALS</th>
        </tr>
      </thead>
      <tbody>
        {temp?.items.map((items) => (
          <tr key={items?.productID} style={{ 
            borderBottom: '1px solid #eee',
            ':hover': { backgroundColor: '#f5f5f5' }
          }}>
            <td style={{ 
              padding: '12px 15px',
              color: '#666'
            }}>
              {items?.productName} × {items?.quantity}
            </td>
            <td style={{ 
              padding: '12px 15px',
              textAlign: 'right',
              color: '#333',
              fontWeight: '500'
            }}>
              ₹{Math.round(items?.dealRate * items?.quantity)}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
  
  <div className="orderTotal">
    <table style={{ 
      width: '100%',
      borderCollapse: 'collapse'
    }}>
      <tbody>
        <tr>
          <th style={{ 
            padding: '10px 15px',
            textAlign: 'left',
            fontWeight: '500',
            color: '#666',
            borderTop: '1px solid #eee'
          }}>Subtotal</th>
          <td style={{ 
            padding: '10px 15px',
            textAlign: 'right',
            borderTop: '1px solid #eee',
            color: '#333',
            fontWeight: '500'
          }}>₹{totalPrice.toFixed(2)}</td>
        </tr>
        <tr>
          <th style={{ 
            padding: '10px 15px',
            textAlign: 'left',
            fontWeight: '500',
            color: '#666'
          }}>Delivery</th>
          <td style={{ 
            padding: '10px 15px',
            textAlign: 'right',
            color: totalPrice >= 1000 ? '#4CAF50' : '#333',
            fontWeight: '500'
          }}>
            {totalPrice >= 1000 ? 'Free' : '₹99'}
          </td>
        </tr>
        <tr>
          <th style={{ 
            padding: '10px 15px',
            textAlign: 'left',
            fontWeight: '600',
            color: '#333',
            borderTop: '1px solid #eee',
            fontSize: '1.1em'
          }}>Total</th>
          <td style={{ 
            padding: '10px 15px',
            textAlign: 'right',
            fontWeight: '600',
            color: '#333',
            borderTop: '1px solid #eee',
            fontSize: '1.1em'
          }}>
            ₹{Math.round(totalPrice >= 1000 ? totalPrice : totalPrice + 99)}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div> */}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <TokenAnimation />
    </div>
  );
};

export default ShoppingCart;
